import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Input from '../Input/Input';
import './PromoCodeModal.css';

const PromoCodeModal = ({
  isOpen,
  onClose,
  onApply,
  onSkip,
  isSubmitting = false,
  title = 'Have a promo code?',
  description = 'Enter your code to get a discount on your screening fee, or skip to continue at the regular price.',
}) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setCode('');
      setError('');
    }
  }, [isOpen]);

  const handleClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const trimmed = code.trim().toUpperCase();
    if (!trimmed) {
      setError('Enter a promo code or choose Skip');
      return;
    }

    setError('');
    onApply(trimmed);
  };

  const handleSkip = () => {
    if (isSubmitting) return;
    onSkip();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Apply promo code"
      shouldCloseOnOverlayClick={!isSubmitting}
      ariaHideApp={false}
      className="promo-code-modal"
      overlayClassName="promo-code-modal-overlay"
    >
      <button
        type="button"
        className="promo-code-modal-close"
        onClick={handleClose}
        disabled={isSubmitting}
        aria-label="Close"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <h2 className="promo-code-modal-title">{title}</h2>
      <p className="promo-code-modal-subtitle">{description}</p>

      <form className="promo-code-modal-form" onSubmit={handleApply}>
        <Input
          type="text"
          name="promoCode"
          label="Promo code"
          placeholder="e.g. SAVE10"
          value={code}
          onChange={(e) => {
            setCode(e.target.value.toUpperCase());
            if (error) setError('');
          }}
          error={error}
          disabled={isSubmitting}
          autoFocus
        />

        <div className="promo-code-modal-actions">
          <button
            type="button"
            className="promo-code-modal-skip-btn"
            onClick={handleSkip}
            disabled={isSubmitting}
          >
            Skip
          </button>
          <button
            type="submit"
            className="promo-code-modal-apply-btn"
            disabled={isSubmitting || !code.trim()}
          >
            {isSubmitting ? 'Please wait...' : 'Apply & continue'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default PromoCodeModal;
